import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontMerriweather, fontRobotoCondensed, theme } from "shared/lib/styles";

import { Headline, SponsorHeadline } from "scmp-app/components/content/content-headline/styles";
import { Date } from "scmp-app/components/content/content-published-date/styles";

export const Item = styled(BaseLink)`
  display: flex;
  flex-direction: column;
  gap: 4px;

  inline-size: 198px;
  block-size: 69px;

  border-inline-end: 1px solid #dfdfdf;

  margin-inline-end: 20px;
  padding-inline-end: 20px;

  color: #000000;
  font-weight: 500;
  font-size: 13px;
  font-family: ${fontMerriweather};
  line-height: 130%;

  ${theme.breakpoints.up("desktop")} {
    inline-size: 269px;
  }

  :hover {
    color: #2957b5;
  }

  ${Date} {
    color: #727272;
    font-weight: 400;
    font-size: 12px;
    font-family: ${fontRobotoCondensed};
    line-height: 14px;
  }

  ${Headline}, ${SponsorHeadline} {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;

    overflow: hidden;
  }
`;

export const MetaWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;

  block-size: 14px;
`;
